import React from 'react';

import Head from 'next/head';

import { getArticlesByPage } from '@/helpers/helpers_data';

import ArticleCards from '@/components/ArticleCards';
import ArticleCardsWithImage from '@/components/ArticleCardsWithImage';
import Footer from '@/components/Footer';
import Header from '@/components/Header';
import Pagination from '@/components/Pagination';
// import Testimonials from '@/components/Testimonials'

const ARTICLES_PER_PAGE = 10;
const PAGE = 1;

export async function getStaticProps() {
  const data = await getArticlesByPage({ limit: ARTICLES_PER_PAGE });

  return {
    props: {
      articles: data.articles,
      total_articles: data.total
    }
  };
}

const News = (props) => {
  return (
    <div className="page-wrapper">
      <Head>
        <title>Find Home Service Pros Near You</title>
        <meta name="description" content="CallAPro - Find a Home Service Professional Near You" />

        <link rel="canonical" href="https://callapro.com/news/" />
      </Head>
      <Header />
      <ArticleCardsWithImage articles={props.articles.slice(0, 3)} />
      <ArticleCards articles={props.articles.slice(3, 10)} />
      <Pagination
        totalPages={props.total_articles <= ARTICLES_PER_PAGE ? 1 : Math.ceil((props.total_articles - ARTICLES_PER_PAGE) / ARTICLES_PER_PAGE + 1)}
        page={PAGE}
        perPage={ARTICLES_PER_PAGE}
        path={`/news`}
      />
      {/*<Testimonials />*/}
      <Footer />
    </div>
  );
};

export default News;
